module.exports = __webpack_public_path__ + "static/media/Authority Bias - mari-lezhava-q65bNe9fW-w-unsplash.3072a6d6.jpg";